import { render, staticRenderFns } from "./student-list-add.vue?vue&type=template&id=7ae3a201&scoped=true&"
import script from "./student-list-add.vue?vue&type=script&lang=js&"
export * from "./student-list-add.vue?vue&type=script&lang=js&"
import style0 from "./student-list-add.vue?vue&type=style&index=0&id=7ae3a201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae3a201",
  null
  
)

export default component.exports